import React from "react";
import styles from "./style.module.css";
import { Link } from "react-router-dom";
const Button = ({ text, path }) => {
  return (
    <div className={styles["btn"]}>
      {path ? <Link to={path}>{text}</Link> : `${text}`}
    </div>
  );
};

export default Button;
